import './libs/commons';
import './css/style.css';
import Nuxeo from 'nuxeo/es5';
import $ from 'jquery';



const nuxeoClient = new Nuxeo({
    baseURL: '/nuxeo'
});

export var languageFilters = [];
export var productFilters = [];
export const queryFilters = [];
export const searchFilters = [];
export const isJumped = [];
export const isALLSelected = [];
export const queryTemp = [];
export var requestType = [];
// all the rows with directory
let rowSet = new Set();
var isClear = false;
var numTimer = 0
var languageAllLists = new Array("Bulgarian", "Croatian", "Czech", "Danish", "Dutch", "English", "Estonian", "Finnish", "French", "German", "Greek", "Hungarian", "Italian", "Lithuanian", "Latvian", "Norwegian", "Polish", "Portuguese", "Romanian", "Russian", "Serbian", "Slovak", "Slovenian", "Spanish", "Swedish", "Turkish", "Ukrainian");
//var categoryAllLists = new Array("Access", "Aspiration Catheter ", "Blood Glucose Monitoring Systems", "Cardiology", "HEMATOLOGY AND HEMOTRANSFUSION DEVICES", "I.V. Catheter", "Imaging", "Infusion Pump & Syringe Pump", "Needle & Syringes", "Perfusion", "Peripheral", "Temporary Occlusion Balloon Catheter");
var categoryAllLists = new Array();
//var categorySelectedLists = new Array();
var queryAllLists = new Array("Aa", "Bb", "Cc", "Dd", "Ee", "Ff", "Gg", "Hh", "Ii", "Jj", "Kk", "Ll", "Mm", "Nn", "Oo", "Pp", "Qq", "Rr", "Ss", "Tt", "Uu", "Vv", "Ww", "Xx", "Yy", "Zz", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9")
//var isResultShouldBeChanged = true;
//var isResultCategoryFreezed = false;
var isLanShouldBeFreezed = false;
var initialTypeList = [];
var initialQueryLanList = [];
var initialLanguageNameList = [];
var initialLanguageKeyList = [];
var typeFilters = [];
var categoryFilters = [];
var initialCategoryNameArray = [];
var initialCategoryCountArray = [];
var initialTypeNameArray = [];
var initialTypeCountArray = [];
var currentLanguageKeyList = [];
var category_type = [];
//var codeOrBrandString = [];
var pageSizeLimite = 10000;
var lanObj = {
    bul: { key: 'Bulgarian' },
    scr: { key: 'Croatian' },
    cze: { key: 'Czech' },
    dan: { key: 'Danish' },
    dut: { key: 'Dutch' },
    eng: { key: 'English' },
    est: { key: 'Estonian' },
    fin: { key: 'Finnish' },
    fre: { key: 'French' },
    ger: { key: 'German' },
    gre: { key: 'Greek' },
    hun: { key: 'Hungarian' },
    ita: { key: 'Italian' },
    lit: { key: 'Lithuanian' },
    lav: { key: 'Latvian' },
    nor: { key: 'Norwegian' },
    pol: { key: 'Polish' },
    por: { key: 'Portuguese' },
    rum: { key: 'Romanian' },
    rus: { key: 'Russian' },
    scc: { key: 'Serbian' },
    slo: { key: 'Slovak' },
    slv: { key: 'Slovenian' },
    spa: { key: 'Spanish' },
    swe: { key: 'Swedish' },
    tur: { key: 'Turkish' },
    ukr: { key: 'Ukrainian' }
}
var lanResetObj = {
    Bulgarian: { key: 'bul' },
    Croatian: { key: 'scr' },
    Czech: { key: 'cze' },
    Danish: { key: 'dan' },
    Dutch: { key: 'dut' },
    English: { key: 'eng' },
    Estonian: { key: 'est' },
    Finnish: { key: 'fin' },
    French: { key: 'fre' },
    German: { key: 'ger' },
    Greek: { key: 'gre' },
    Hungarian: { key: 'hun' },
    Italian: { key: 'ita' },
    Lithuanian: { key: 'lit' },
    Latvian: { key: 'lav' },
    Norwegian: { key: 'nor' },
    Polish: { key: 'pol' },
    Portuguese: { key: 'por' },
    Romanian: { key: 'rum' },
    Russian: { key: 'rus' },
    Serbian: { key: 'scc' },
    Slovak: { key: 'slo' },
    Slovenian: { key: 'slv' },
    Spanish: { key: 'spa' },
    Swedish: { key: 'swe' },
    Turkish: { key: 'tur' },
    Ukrainian: { key: 'ukr' }
}
$(document).ready(function () {
    setCategoryAllLists();
});

export function fetchDocuments(param) {

    if (languageFilters.length > 0) {
        param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
    }
    if (isClear) {
        if (languageFilters.length == 0) {
            languageFilters.push("error");
            param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
            languageFilters.pop();
        }
    }
    if (productFilters.length > 0) {
        //param.terumo_producttype_agg = JSON.stringify(productFilters);
    }

    //入力したCodeまたBrandnameを保存する
    /*if(param.hasOwnProperty("terumo_ifu_brandName_agg"))
        if (param.terumo_ifu_brandName_agg.length > 0){
            codeOrBrandString.push(param.terumo_ifu_brandName_agg);
        }
    if(param.hasOwnProperty("terumo_ifu_productCodes"))
        if(param.terumo_ifu_productCodes.length > 0){
            codeOrBrandString.push(param.terumo_ifu_productCodes);
        }*/

    if ((!Object.prototype.hasOwnProperty.call(param, "terumo_ifu_brandName_or_productCodes_ILIKE")) && (searchFilters.length > 0)) {
        param.terumo_ifu_brandName_or_productCodes_ILIKE = searchFilters[0];
    }

    param.pageSize = JSON.stringify(pageSizeLimite);
    param.sortBy = "terumo_ifu:brandName,terumo_wf:releaseDate";
    param.sortOrder = "ASC,DESC";
    // request API with parameter productCategory != "Australia" 
    // terumo_ifu_productCategory_1 is the predicates for productCategory
    // in website-search
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                //   return;
            }
            //resultPageDocumentList(data.entries);
            updateFilters(data.aggregations, data);
            if (isJumped.length > 0) {
                resultPageDocumentList(data.entries);
                updateQuerypageZFilters(data.aggregations, "brand&code");
            }
            updateDocumentList(data.entries);
        })
        .catch(error => {
            console.log(error);
        });
}

export function fetchDocumentsAll(param) {

    languageFilters = [];
    productFilters = [];

    param.pageSize = JSON.stringify(pageSizeLimite);
    // request API with parameter productCategory != "Australia" 
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                //   return;
            }
            resultPageDocumentList(data.entries);
            updateFilters(data.aggregations, data);
            if (isJumped.length > 0) {
                updateQuerypageZFilters(data.aggregations, "brand&code");
            }
            updateDocumentList(data.entries);
        })
        .catch(error => {
            console.log(error);
        });
}

function setCategoryAllLists() {

    let queryParams = {}
    queryParams.pageSize = JSON.stringify(pageSizeLimite);
    queryParams.sortBy = "dc:title";
    queryParams.sortOrder = "ASC";
    
    nuxeoClient.request('search/pp/website-product-categories/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: queryParams
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                return;
            }
            for (var i = 0; i < data.entries.length; i++) {
                var productCategory = data.entries[i].properties['dc:title'];
                //var productCategory = data.entries[i].properties['terumo_ifu:productCategory'];

                // forbidden Australia in categoryAllLists
                if (productCategory && productCategory != "Australia" && productCategory != "Package Insert"
                    && productCategory != "IFU") {
                    categoryAllLists.push(productCategory);
                }
            }
            categoryAllLists = categoryAllLists.filter((item, idx, array) => {
                return array.indexOf(item) === idx;
            });
        })
        .catch(error => {
            console.log(error);
        });
}

export function fetchNewsDocuments(param) {
    param.pageSize = JSON.stringify(pageSizeLimite);
    param.sortBy = "terumo_wf:releaseDate";
    param.sortOrder = "DESC";
    // request API with parameter productCategory != "Australia" 
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                return;
            }
            updateNews(data.entries);
        })
        .catch(error => {
            console.log(error);
        });
}

function updateNews(documents) {
    const latestNews = $("#SHLatestNews");
    var dt = new Date();
    dt.setMonth(dt.getMonth() - 6);
    var Year = dt.getFullYear();
    var Month = (dt.getMonth() + 1);
    var Day = dt.getDate();
    if (Month < 10) Month = "0" + Month;
    if (Day < 10) Day = "0" + Day;
    var sixMonthsAgo = Year.toString() + "-" + Month + "-" + Day;
    if (documents.length === 0) {
        latestNews.html("No Results");
        return;
    }
    var monthSimpleWord = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    var lastetDateSimple = "";
    let elements = [];
    documents.forEach(entry => {
        var changeJapanDate = new Date(entry.properties['terumo_wf:releaseDate']);
        changeJapanDate.setTime(changeJapanDate.getTime() + 1000 * 60 * 60 * 9);
        var releaseDate = changeJapanDate.toISOString().split('T');
        var reWordDate = releaseDate[0].split('-');

        var yearSimple = reWordDate[0];
        var monthSimple = monthSimpleWord[reWordDate[1] - 1];
        var daySimple = reWordDate[2];
        lastetDateSimple = yearSimple + "-" + monthSimple + "-" + daySimple;

        var ifuAndimplantCard = "-";
        if (entry.properties['terumo_ifu:implantCard'] && entry.properties['terumo_ifu:e-IFU']) {
            ifuAndimplantCard = "e-IFU, Implant card";
        } else if (entry.properties['terumo_ifu:implantCard']) {
            ifuAndimplantCard = "Implant card";
        } else if (entry.properties['terumo_ifu:e-IFU']) {
            ifuAndimplantCard = "e-IFU";
        }

        var lanList = entry.properties['terumo_ifu:languages'];
        lanList = replaceLanguage(lanList);
        var lanAllList = lanList.join(" / ");
        lanAllList = lanAllList.toUpperCase();

        var filePath = "";
        if (isEmpty(entry.properties['file:content'])) {
            // empty
        } else {
            filePath = entry.properties['file:content'].data;
        }

        if (sixMonthsAgo < releaseDate[0]) {
            elements.push('<div class="news"><div class="tit">' + lastetDateSimple + '   Terumo Corporation</div><div class="info">Brand name : <span class="break">' + entry.properties['terumo_ifu:brandName'] + '</span> / Language : <a href=' + filePath + '>' + lanAllList + "</a> / " + ifuAndimplantCard + '</div></div>');
        } else {
            elements.push('<div class="storage"><div class="news"><div class="tit">' + lastetDateSimple + '   Terumo Corporation</div><div class="info">Brand name : <span class="break">' + entry.properties['terumo_ifu:brandName'] + '</span> / Language : <a href=' + filePath + '>' + lanAllList + "</a> / " + ifuAndimplantCard + '</div></div></div>');
        }
    });
    latestNews.html(elements);
    numTimer++;
    afterTimer();
}

function replaceLanguage(lanList) {

    for (var i = 0; i < lanList.length; i++) {
        var keyObj = lanObj[lanList[i]];
        lanList[i] = keyObj.key;
    }
    lanList.sort();
    for (var j = 0; j < lanList.length; j++) {
        var keyObjReset = lanResetObj[lanList[j]];
        lanList[j] = keyObjReset.key;
    }
    return lanList;
}

//get filename function
function getFileName(doc) {
    return doc.path.split('/')[5];
}

//sort filename function
function fileNameSort(lists) {

    for (var i = 0; i < lists.length - 1; i++)
        for (var j = 0; j < lists.length - 1 - i; j++) {
            let fileName_j = getFileName(lists[j]);
            let fileName_j1 = getFileName(lists[j + 1]);
            if (fileName_j.toUpperCase() > fileName_j1.toUpperCase()) {
                var temp = lists[j];
                lists[j] = lists[j + 1];
                lists[j + 1] = temp;
            }
        }


    return lists;
}

function sortByWhat(list, key) {
    let i, j, temp;
    //Language(正式表記の内容で昇順)
    if (key == "language") {
        var lanLongList = [];
        for (i = 0; i < list.length; i++) {
            let lanShortList_each = list[i].properties['terumo_ifu:languages'].slice();
            for (j = 0; j < lanShortList_each.length; j++) {
                var keyObj = lanObj[lanShortList_each[j]];
                lanShortList_each[j] = keyObj.key;
            }
            lanShortList_each.sort();
            let str_lan = lanShortList_each.join('');
            lanLongList.push(str_lan);
        }
        //console.log(lanLongList);
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                let lan1 = lanLongList[j];
                let lan2 = lanLongList[j + 1];
                if (lan1 > lan2) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                    temp = lanLongList[j];
                    lanLongList[j] = lanLongList[j + 1];
                    lanLongList[j + 1] = temp;
                }
            }

    }
    //Issue Date (降順) 
    else if (key == "issuedate") {
        var date_list = [];
        for (i = 0; i < list.length; i++) {
            let issuedateArray = new Array();
            issuedateArray = list[i].properties['terumo_ifu:IFU'].split('/');
            let st1 = issuedateArray[issuedateArray.length - 1];
            if (typeof (st1) != 'undefined') {
                st1 = st1.trim();
            }
            // console.log(st1);
            let date = new Date(Date.parse(st1));
            if (isNaN(date.getTime()))
                date = new Date(Date.parse('1900-01-01'));
            date_list.push(date);
        }
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                let date1 = date_list[j];
                let date2 = date_list[j + 1];
                if (date1 < date2) {
                    var temp1 = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp1;
                    var temp2 = date_list[j];
                    date_list[j] = date_list[j + 1];
                    date_list[j + 1] = temp2;
                }

            }

    }
    //Version
    else if (key == "versionLabel") {
        list.sort(function (a, b) {
            return b.versionLabel - a.versionLabel;
        });
    }
    //Fake brandname
    else if (key == "brandname") {
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                if (list[j].properties['terumo_ifu:brandName'] > list[j + 1].properties['terumo_ifu:brandName']) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                }

            }
    }
    // e-IFUの集約のキー(昇順) versionableID
    else {
        for (i = 0; i < list.length - 1; i++)
            for (j = 0; j < list.length - 1 - i; j++) {
                if (list[j].versionableId > list[j + 1].versionableId) {
                    temp = list[j];
                    list[j] = list[j + 1];
                    list[j + 1] = temp;
                }
            }
    }
}

//結果画面右側のResult Tableを取得と表示
function resultPageDocumentList(documents) {
    const productListEl = $("#RTresult");

    const resultCount = $("#RtotalNumber");
    //let count =[];
    //count.push('<p>' + "Result = " + documents.length + '</p>');
    //resultCount.html(count);
    resultCount.text("Result = " + documents.length);

    if (documents.length === 0) {
        productListEl.html("No Results");
        return;
    }



    //sort by file name in same type
    var currentType = "";

    let to_sort_documents = [];
    let sorted_documents = [];
    if (requestType[0] == "lanCategory") {
        for (var doci = 0; doci < documents.length; doci++) {
            if ((currentType != documents[doci].properties['terumo:producttype']) && (to_sort_documents.length > 0)) {

                sorted_documents = sorted_documents.concat(fileNameSort(to_sort_documents));
                to_sort_documents = [];
            }
            currentType = documents[doci].properties['terumo:producttype'];
            to_sort_documents.push(documents[doci]);
        }
        sorted_documents = sorted_documents.concat(fileNameSort(to_sort_documents));
    }
    else {
        to_sort_documents = documents.slice();
        sorted_documents = sorted_documents.concat(fileNameSort(to_sort_documents));
    }
    documents = sorted_documents;




    var parent = document.getElementById("RTresult");
    while (parent.hasChildNodes()) {
        parent.removeChild(parent.firstChild);
    }

    let elements = [];

    //split into document_lists
    // var current_filename = documents[0].properties['dc:title'];
    var current_filename = "";
    //var current_productType = documents[0].properties['terumo:producttype'];
    var current_productType = "";
    var current_category = "";
    //var str_html = '';

    var document_lists = [];
    var brand_index = 0;
    rowSet = new Set();
    var index_all = 0;
    var can_sort = false;
    var should_sort = false;
    var first_doc = true;
    var new_type = false;
    var start_index = 0;
    var new_cat = false;
    rowSet.add(index_all);
    documents.forEach(entries => {
        if (requestType[0] == "lanCategory") {
            if ((current_filename != getFileName(entries)) || (current_productType != entries.properties['terumo:producttype']) || (current_category != entries.properties['terumo_ifu:productCategory'])) {
                if (can_sort)
                    should_sort = true;
            }
        }
        else {
            if (current_filename != getFileName(entries)) {
                if (can_sort)
                    should_sort = true;
            }
        }

        if (first_doc) {
            first_doc = false;
            can_sort = true;
        }

        if (should_sort) {
            //sort document list 
            // language sort
            sortByWhat(document_lists, "language");
            // issueDate sort
            sortByWhat(document_lists, "issuedate");
            //versionLabel sort
            sortByWhat(document_lists, "versionLabel");
            // versionableID sort
            sortByWhat(document_lists, "versionableId");
            // fake_brandname sort
            sortByWhat(document_lists, "brandname");
            var new_list = generate_boxes(document_lists);
            //print one brandname of documents
            print_document_table(new_list, brand_index, elements, start_index);

            document_lists = [];
            brand_index += 1;
            elements = [];
            should_sort = false;
        }
        if (requestType[0] == "lanCategory") {
            if (current_category != entries.properties['terumo_ifu:productCategory']) {
                current_category = entries.properties['terumo_ifu:productCategory'];
                new_cat = true;
            }
            if ((current_productType != entries.properties['terumo:producttype']) || (new_cat)) {
                // print productType 
                elements.push('<div class="resultListTitle"><span>' + entries.properties['terumo:producttype'] + "</span><br></div>");
                current_productType = entries.properties['terumo:producttype'];
                new_type = true;
                new_cat = false;
            }
            if ((current_filename != getFileName(entries)) || (new_type)) {
                // print brandname
                elements.push('<div class="resultListTitle1"><span>&nbsp;&nbsp;' + getFileName(entries) + '</span></div>');
                rowSet.add(index_all);
                current_filename = getFileName(entries);
                new_type = false;
                start_index = index_all;
            }
        }
        else {
            if (current_filename != getFileName(entries)) {
                // print brandname
                elements.push('<div class="resultListTitle1"><span>&nbsp;&nbsp;' + getFileName(entries) + '</span></div>');
                rowSet.add(index_all);
                current_filename = getFileName(entries);
                new_type = false;
                start_index = index_all;
            }
        }





        document_lists.push(entries);
        index_all += 1;

    })

    //rowSet.add(index_all);
    //elements.push('<div class="resultListTitle"><span>'+current_productType+"</span><br></div>");
    //elements.push('<div class="resultListTitle1"><span>&nbsp;&nbsp;'+current_filename+'</span></div>');
    // language sort
    sortByWhat(document_lists, "language");
    // issueDate sort
    sortByWhat(document_lists, "issuedate");
    //versionLabel sort
    sortByWhat(document_lists, "versionLabel");
    // versionableID sort
    sortByWhat(document_lists, "versionableId");
    // fake_brandname sort
    sortByWhat(document_lists, "brandname");
    var new_list = generate_boxes(document_lists);

    // print last brandname of documents
    print_document_table(new_list, brand_index, elements, start_index);

    old_version_event();
    // リストのイベント発生用
    ListEvent();
}

function generate_boxes(document_lists) {
    var new_list = [];
    var doclist_samename = [];
    var last_brandname = "";
    for (var i = 0; i < document_lists.length; i++) {
        if ((last_brandname != document_lists[i].properties['terumo_ifu:brandName']) && (doclist_samename.length > 0)) {
            // generate drawers
            var new_doc_list = generate_drawers(doclist_samename);
            new_list = new_list.concat(new_doc_list);
            doclist_samename = [];
        }
        last_brandname = document_lists[i].properties['terumo_ifu:brandName'];
        doclist_samename.push(document_lists[i]);
    }
    if (doclist_samename.length > 0) {
        new_doc_list = generate_drawers(doclist_samename);
        new_list = new_list.concat(new_doc_list);
    }
    return new_list;
}

function generate_drawers(documents) {
    //generate language labels
    var lanLongList = [];
    for (var i = 0; i < documents.length; i++) {

        let lanShortList_each = documents[i].properties['terumo_ifu:languages'].slice();
        for (var j = 0; j < lanShortList_each.length; j++) {
            var keyObj = lanObj[lanShortList_each[j]];
            lanShortList_each[j] = keyObj.key;
        }
        lanShortList_each.sort();
        let str_lan = lanShortList_each.join('');
        lanLongList.push(str_lan);
    }


    var doc_box = [];
    var label_box = [];
    var doclist_sameVID = [];
    var last_VID = "";
    var first_lan = lanLongList[0];
    for (i = 0; i < documents.length; i++) {
        if ((last_VID != documents[i].versionableId) && (doclist_sameVID.length > 0)) {
            // generate doc and label boxes
            doc_box.push(doclist_sameVID);
            label_box.push(first_lan);
            first_lan = lanLongList[i];
            doclist_sameVID = [];
        }
        last_VID = documents[i].versionableId;
        doclist_sameVID.push(documents[i]);
    }
    if (doclist_sameVID.length > 0) {
        doc_box.push(doclist_sameVID);
        label_box.push(first_lan);
    }
    //sort by language label

    for (i = 0; i < label_box.length - 1; i++)
        for (j = 0; j < label_box.length - 1 - i; j++) {
            if (label_box[j] > label_box[j + 1]) {
                var temp = label_box[j];
                label_box[j] = label_box[j + 1];
                label_box[j + 1] = temp;
                var arr_temp = doc_box[j].slice();
                doc_box[j] = doc_box[j + 1].slice();
                doc_box[j + 1] = arr_temp.slice();

            }
        }

    var new_doc_list = [];
    for (i = 0; i < doc_box.length; i++) {
        for (j = 0; j < doc_box[i].length; j++) {
            new_doc_list.push(doc_box[i][j]);
        }
    }
    return new_doc_list;

}

function print_document_table(documents, brand_index, elements, document_index) {

    var tableID = "RTresult" + brand_index;
    var parent = document.getElementById("RTresult");

    // push the brand_indexth table into elements
    var div = document.createElement("div");
    div.setAttribute("id", tableID);
    div.setAttribute("class", "resultList");

    parent.appendChild(div);


    var productList_each = $("#" + tableID);

    //old version html start
    let old_version_html_start1 = `<div class="oldVer">`;
    let old_version_html_start2 = `<div class="oldVerWrap">`;
    //let old_version_html_start = `<div class="oldVer"><div class="oldVerWrap">`;
    //old version html end
    let old_version_html_end = `</div></div></div>`;
    let old_version_button = `<div class="btnOld"><button><span>Old Version</span><span>Close</span></button></div>`;
    // if the current document is in old version state
    let in_old = false;
    //judge whether old-version finished
    let old_notfinish = false;
    let last_versionableId = "";
    var strHtml = "";
    documents.forEach(entry => {
        if ((entry.versionableId != last_versionableId) && (in_old)) {
            strHtml = strHtml + old_version_html_end;
            strHtml = strHtml + old_version_button;
            elements.push(strHtml);
            strHtml = "";
            in_old = false;
            old_notfinish = false;
            rowSet.add(document_index);
        }
        if ((entry.versionableId == last_versionableId) && (!in_old)) {
            let strHtml_head = '';
            strHtml = old_version_html_start1 + strHtml_head + old_version_html_start2;
            // strHtml = old_version_html_start ;
            strHtml = strHtml + ' <div class="resultOldVerTitle">' + getFileName(entry) + '</div> <a href="" class="btnClose"></a><div class="oldVerWrapInr">';
            //strHtml = strHtml + elements.pop();
            in_old = true;
            old_notfinish = true;
        }

        var changeJapanDate = new Date(entry.properties['terumo_wf:releaseDate']);
        changeJapanDate.setTime(changeJapanDate.getTime() + 1000 * 60 * 60 * 9);
        var releaseDate = changeJapanDate.toISOString().split('T');
        var factoryList = entry.properties['terumo_ifu:factories'];
        if (isEmpty(factoryList)) {
            factoryList = "-";
        } else {
            factoryList = entry.properties['terumo_ifu:factories'].map(item => item.grouplabel);
        }
        var ifuAndimplantCard = "-";
        if (entry.properties['terumo_ifu:implantCard'] && entry.properties['terumo_ifu:e-IFU']) {
            ifuAndimplantCard = '<span class="icon blue">e-IFU</span><span class="icon orange">IC</span>';
        } else if (entry.properties['terumo_ifu:implantCard']) {
            ifuAndimplantCard = '<span class="icon orange">IC</span>';
        } else if (entry.properties['terumo_ifu:e-IFU']) {
            ifuAndimplantCard = '<span class="icon blue">e-IFU</span>';
        }

        var lanList = entry.properties['terumo_ifu:languages'];
        lanList = replaceLanguage(lanList);
        var lanAllList = lanList.join(" / ");
        lanAllList = lanAllList.toUpperCase();

        var filePath = "";
        if (isEmpty(entry.properties['file:content'])) {
            // empty
        } else {
            filePath = `'` + entry.properties['file:content'].data + `'`;
        }

        //入力したcodeまだBrandnameを太字になる
        //elements.push('<div class="item"><div class="itemHead"><table class="tb-brand"><thead><tr><th><span>Brand name</span></th><th><span>Product codes</span></th></tr></thead><tbody><tr><td>'+entry.properties['dc:title']+'</td><td>'+entry.properties['terumo_ifu:productCodes']+'</td></tr></tbody></table><table class="tb-lang"><thead><tr><th><span>Language</span></th><th><span></span></th><th><span>Detail</span></th></tr></thead><tbody><tr><td class="lang"><ul class="ul-lang"><li><a href="'+filePath+'">' + lanAllList + '</a></li></ul></td><td class="detail">'+ifuAndimplantCard+'</td><td class="detail"><button class="btnCircle"></button></td></tr></tbody></table></div><div class="info"><table class="tb-info"><thead><tr><th>EC Rep / Factory / Manufacturer</th><th>IFU revision / Issue date</th><th>Valid from Serial Nr .. / Lot Nr</th></tr></thead><tbody><tr><td data-title="EC Rep / Factory / Manufacturer"><span>' + entry.properties['terumo_ifu:ec-rep'] +" / "+ factoryList + " / " +entry.properties['terumo_ifu:manufacturer']+'</span></td><td data-title="IFU revision / Issue date"><span>' + entry.properties['terumo_ifu:IFU'] + " / " + releaseDate[0] +'</span></td><td data-title="alid from Serial Nr .. / Lot Nr"><span>' +isEmptyReturnVelue(entry.properties['terumo_ifu:serialNumber'])+ " / " + isEmptyReturnVelue(entry.properties['terumo_ifu:lotNumber']) +'</span></td></tr></tbody></table></div></div>');
        var button_head = '<th><span><b>Detail</b></span></th>';
        var button_name = 'btnCircle';
        var button_html = `<td class="detail"><button class="` + button_name + `"></button></td>`;
        if (in_old) {
            button_head = '';
            button_html = '';
        }
        //<a href="javascript:void(0);" target='_self' title='Download' onclick="window.open(` + filePath + `,'Download'); ">
        var subStr01 = '<div class="item"><div class="itemHead"><table class="tb-brand"><thead><tr><th><span><b>Product Code</b></span></th><th><span><b>IFU Revision / Issue date</b></span></th></tr></thead><tbody><tr><td>';
        var subStr02 = entry.properties['terumo_ifu:productCodes'];
        var subStr03 = '</td><td>' + entry.properties['terumo_ifu:IFU'] + '</td></tr></tbody></table>' + '<table class="tb-lang"><thead><tr><th><span><b>Language</b></span></th><th><span><b>Icon<b></span></th>' + button_head + '</tr></thead>' +
            `<tbody><tr><td class="lang"><ul class="ul-lang"><li><a href=` + filePath + `>` + lanAllList + '</a></li></ul></td><td class="detail">' + ifuAndimplantCard + '</td>' + button_html + '</tr></tbody></table></div><div class="info"><table class="tb-info"><thead><tr><th><b>EC Rep</b></th><th><b>Release date</b></th><th><b>Valid from Serial Nr. / Lot Nr.</b></th><th><b>Factory / Manufacturer</b></th></tr></thead>' +
            '<tbody><tr><td data-title="EC Rep"><span>' + entry.properties['terumo_ifu:ec-rep'] +
            '</span></td><td data-title="Release date"><span>' + releaseDate[0] +
            '</span></td><td data-title="Valid from Serial Nr. / Lot Nr."><span>' + isEmptyReturnVelue(entry.properties['terumo_ifu:serialNumber']) + " / " + isEmptyReturnVelue(entry.properties['terumo_ifu:lotNumber']) +
            '</span></td><td data-title="Factory / Manufacturer"><span>' + factoryList + " / " + entry.properties['terumo_ifu:manufacturer'] +
            '</span></td></tr></tbody></table></div></div>';


        if (isEmpty(queryTemp[0])) {
            for (var h = 1; h < subStr02.length; h++) {
                subStr02[h] = "<br>" + subStr02[h];
            }
            strHtml = strHtml + subStr01 + subStr02 + subStr03;
            // if((entry.versionableId != last_versionableId) && (in_old)){
            //     strHtml = strHtml + old_version_html_end;
            //     in_old = false;
            // }

            if (!in_old) {
                elements.push(strHtml);
                strHtml = "";
            }
            else {
                rowSet.add(document_index);
            }


        } else {

            // //title 太字
            var queryTemp_upper = queryTemp[0].toUpperCase();
            //var subStr02_upper = subStr02.toUpperCase();
            // for (var i = 0; i < subStr02.length - queryTemp[0].length; i++) {
            //     var strUnbold02;
            //     var strUnbold02_upper;
            //     strUnbold02_upper = subStr02_upper.substring(i, i + queryTemp[0].length);
            //     strUnbold02 = subStr02.substring(i, i + queryTemp[0].length);

            //     if (strUnbold02_upper == queryTemp_upper) {
            //         subStr02 = subStr02.substring(0, i) + '<b>' + strUnbold02 + '</b>' + subStr02.substring(i + queryTemp[0].length, subStr02.length - 1);
            //         break;
            //     }
            // }

            //code 太字
            for (var j = 0; j < subStr02.length; j++) {
                var subStr02_upper;
                subStr02[j] = subStr02[j] + ' ';
                subStr02_upper = subStr02[j].toUpperCase();
                if (subStr02[j].length > queryTemp[0].length) {
                    for (var k = 0; k < subStr02[j].length - queryTemp[0].length; k++) {

                        var strUnbold04;
                        var strUnbold04_upper;
                        strUnbold04_upper = subStr02_upper.substring(k, k + queryTemp[0].length);
                        strUnbold04 = subStr02[j].substring(k, k + queryTemp[0].length);

                        if (strUnbold04_upper == queryTemp_upper) {
                            subStr02[j] = subStr02[j].substring(0, k) + '<b>' + strUnbold04 + '</b>' + subStr02[j].substring(k + queryTemp[0].length, subStr02[j].length - 1);
                            break;
                        }
                    }
                }
                if (j > 0)
                    subStr02[j] = "<br>" + subStr02[j];

            }
            strHtml = strHtml + subStr01 + subStr02 + subStr03;
            if (!in_old) {
                elements.push(strHtml);
                strHtml = "";
            }
            else {
                rowSet.add(document_index);
            }
        }

        last_versionableId = entry.versionableId;
        document_index += 1;
    });

    if (old_notfinish) {
        strHtml = strHtml + old_version_html_end;
        strHtml = strHtml + old_version_button;
        elements.push(strHtml);
        strHtml = "";
        in_old = false;
        old_notfinish = false;
        rowSet.add(document_index);
    }
    productList_each.html(elements);



}

function updateFilters(aggregates, data) {
    updateAggregateFilter("#langageslist", aggregates.terumo_ifu_languages_agg.buckets, languageFilters, data);
    if (categoryAllLists.length == 0) {
        setCategoryAllLists();
        setTimeout(function () {
            updateAggregateFilter("#productlist", aggregates.terumo_producttype_agg.buckets, productFilters, data);
            numTimer++;
            afterTimer();
        }, 2000);
    } else {
        updateAggregateFilter("#productlist", aggregates.terumo_producttype_agg.buckets, productFilters, data);
        numTimer++;
        afterTimer();
    }
}

//言語リストを取得
function updateAggregateFilter(selector, buckets, values, data) {
    // Build DOM
    const categorytListEl = $(selector);
    const elements = [];

    if (selector == "#langageslist") {
        for (var i = 0; i < languageAllLists.length; i++) {
            elements.push(`<li><label><input type="checkbox" id=` + languageAllLists[i] + ` disabled><span></span><span>` + languageAllLists[i] + ` </span></label></li>`);
        }

        buckets.forEach(entry => {
            let key = entry.key;
            //let docCount = entry.docCount;
            if (entry.fetchedKey && entry.fetchedKey.properties) {
                let label = entry.fetchedKey.properties.label;
                //let count = entry.docCount;
                let checked = values.indexOf(key) >= 0 ? "checked" : "";
                if (languageAllLists.indexOf(label) > -1) {
                    elements.splice(languageAllLists.indexOf(label), 1, `<li><label><input id="${key}" name="${key}" type="checkbox" ${checked}><span></span><span>${label} </span></label></li>`);
                }
            }
        });
        elements.unshift(`<ul class="vertical language">`);
        elements.push(`</ul>`);
    }

    if (selector == "#productlist") {

        for (var j = 0; j < categoryAllLists.length; j++) {
            elements.push(`<li><label><input type="checkbox" id=` + categoryAllLists[j] + ` disabled><span></span><span>` + categoryAllLists[j] + `</span></label></li>`);
        }

        for (var k = 0; k < data.entries.length; k++) {
            var productCategory = data.entries[k].properties['terumo_ifu:productCategory'];
            //let checked = values.indexOf(productCategory) >= 0 ? "checked" : "";
            if (categoryAllLists.indexOf(productCategory) > -1) {
                elements.splice(categoryAllLists.indexOf(productCategory), 1, `<li><label><input id="${productCategory}" name="${productCategory}" type="checkbox" ><span></span><span>${productCategory}</span></label></li>`);
            }
        }
        elements.unshift(`<ul class="vertical products">`);
        elements.push(`</ul>`);
    }



    categorytListEl.html(elements.join("\n"));
    topListSet();

    // Add listeners
    $(selector + " input").click(function (e) {
        if (e.target.checked) {
            values.push(e.target.id);
        } else {
            if (values.indexOf(e.target.id) >= 0) {
                values.splice(values.indexOf(e.target.id), 1);
            }
        }
        if (selector == "#langageslist") {
            $("input:checkbox[id='SallLcbox']").prop("checked", false);
        }
        if (selector == "#langageslist" && values.length == 0) {
            $("input:checkbox[id='SallLcbox']").prop("checked", true);
            var SallLcboxCheck = $("input:checkbox");
            for (var i = 1; i < SallLcboxCheck.length; i++) {
                $("input:checkbox[id='" + SallLcboxCheck[i].id + "']").prop("checked", false);
            }
        }
        var unChecked = 0;
        var SallLcboxCheckDisabled = $("input:checkbox");
        for (var j = 0; j < SallLcboxCheckDisabled.length; j++) {
            if (SallLcboxCheckDisabled[j].checked) {
                unChecked++;
            }
        }
        if (unChecked == 0) {
            document.getElementById("SHsearch").disabled = true;
        } else {
            document.getElementById("SHsearch").disabled = false;
        }
        if (selector == "#langageslist") {
            let queryParams = {};
            fetchDocuments(queryParams);
        }
    });
}

export function fetchResultPageDocuments(param) {
    if (languageFilters.length > 0) {
        param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
    }
    if (isClear) {
        if (languageFilters.length == 0) {
            languageFilters.push("error");
            param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
            languageFilters.pop();
        }
    }
    if ((typeFilters.length == 0) && (productFilters.length > 0)) {

        param.terumo_ifu_productCategory = JSON.stringify(productFilters);
        //param.terumo_ifu_productCategory = "("+ param.terumo_ifu_productCategory+")*";

    }
    if (typeFilters.length > 0) {
        param.es_productCategoryAndtype_agg = JSON.stringify(typeFilters);
        //param.terumo_producttype = JSON.stringify(typeFilters);
    }
    if (isClear) {
        if (typeFilters.length == 0) {
            typeFilters.push("error");
            param.terumo_producttype = JSON.stringify(typeFilters);
            typeFilters.pop();
        }
    }

    param.pageSize = JSON.stringify(pageSizeLimite);
    param.sortBy = "terumo_ifu:productCategory,terumo:producttype";
    param.sortOrder = "ASC,ASC";
    // request API with parameter productCategory != "Australia" 
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                //    return;
            }
            let sorted_entries = dataEntrySort(data.entries);
            resultPageDocumentList(sorted_entries);
            updateResultPageFilters(data.aggregations, sorted_entries);
            updateDocumentList(data.entries);

        })
        .catch(error => {
            console.log(error);
        });
}

// pre-sort for data.entries;
function dataEntrySort(documents) {
    let sorted_entries = documents.slice();
    let i, j, temp;
    //sort by productTypes
    for (i = 0; i < sorted_entries.length - 1; i++)
        for (j = 0; j < sorted_entries.length - 1 - i; j++) {
            if (sorted_entries[j].properties['terumo:producttype'] > sorted_entries[j + 1].properties['terumo:producttype']) {
                temp = sorted_entries[j];
                sorted_entries[j] = sorted_entries[j + 1];
                sorted_entries[j + 1] = temp;
            }

        }
    //sort by productCategory
    for (i = 0; i < sorted_entries.length - 1; i++)
        for (j = 0; j < sorted_entries.length - 1 - i; j++) {
            if (sorted_entries[j].properties['terumo_ifu:productCategory'] > sorted_entries[j + 1].properties['terumo_ifu:productCategory']) {
                temp = sorted_entries[j];
                sorted_entries[j] = sorted_entries[j + 1];
                sorted_entries[j + 1] = temp;
            }

        }
    return sorted_entries;
}
function updateResultPageFilters(aggregates, documents) {


    updateResultFilter("#res_languagelist", languageFilters, documents, aggregates.terumo_ifu_languages_agg);

    if (isJumped.length > 0)
        isJumped.pop();



    typeFilters = [];
    categoryFilters = [];
    updateResultFilter("#res_productlist", typeFilters, documents, aggregates.terumo_producttype_agg);

}

function updateResultFilter(selector, values, documents, aggregate) {
    const resultPageList = $(selector);
    const elements = [];

    if (selector == "#res_languagelist") {
        if (isJumped.length > 0) {
            //push all available langs from result into language filter 
            var availableLanguage = [];
            aggregate.buckets.forEach(entry => {
                let key = entry.key;
                availableLanguage.push(key);
            })
            var str4 = [];
            while (values.length > 0) {
                var popString = values.pop();
                if (availableLanguage.indexOf(popString) >= 0)
                    str4.push(popString);
            }
            while (str4.length > 0) {
                values.push(str4.pop());
            }
        }
        if (initialLanguageNameList.length == 0) {
            aggregate.buckets.forEach(entry => {
                let key = entry.key;
                if (entry.fetchedKey && entry.fetchedKey.properties) {
                    let label = entry.fetchedKey.properties.label;
                    if (isALLSelected.length == 0) {
                        if (aggregate.selection.indexOf(key) >= 0) {
                            initialLanguageNameList.push(label);
                            initialLanguageKeyList.push(key);
                        }
                    }
                    else {
                        initialLanguageNameList.push(label);
                        initialLanguageKeyList.push(key);
                    }

                }
            })
            //sort language namelist from a to z
            // initialLanguageNameList.sort();
            // initialLanguageKeyList.sort();
            for (var i = 0; i < initialLanguageNameList.length - 1; i++) {
                for (var j = i + 1; j < initialLanguageNameList.length; j++) {
                    if (initialLanguageNameList[i] > initialLanguageNameList[j]) {
                        var tmp = initialLanguageNameList[j];
                        initialLanguageNameList[j] = initialLanguageNameList[i];
                        initialLanguageNameList[i] = tmp;
                        tmp = initialLanguageKeyList[j];
                        initialLanguageKeyList[j] = initialLanguageKeyList[i];
                        initialLanguageKeyList[i] = tmp;
                    }
                }
            }

        }
        if (languageFilters.length > 0) {
            for (i = 0; i < initialLanguageNameList.length; i++) {
                elements.push(`<li><label><input id="${initialLanguageKeyList[i]}" name="${initialLanguageKeyList[i]}" type="checkbox" ><span></span><span>` + initialLanguageNameList[i].toUpperCase() + ` </span></label></li>`);
            }
            var newLanguagelist = [];
            aggregate.buckets.forEach(entry => {
                let key = entry.key;
                if (entry.fetchedKey && entry.fetchedKey.properties) {
                    let label = entry.fetchedKey.properties.label;
                    //let count = entry.docCount;
                    let checked = values.indexOf(key) >= 0 ? "checked" : "";
                    if ((initialLanguageNameList.indexOf(label) >= 0) && (values.indexOf(key) >= 0)) {
                        // elements.push(`<li> <label> <input type="checkbox" id="${key}" name="${key}" checked ="${checked}"><span></span><span>${label}</span></label></li>`);
                        var labelUpper = label.toUpperCase();
                        elements.splice(initialLanguageNameList.indexOf(label), 1, `<li><label><input id="${key}" name="${key}" type="checkbox" ${checked}><span></span><span>${labelUpper} </span></label></li>`);
                        newLanguagelist.push(key);
                    }
                }
            });
            while (values.length > 0)
                values.pop();
            while (newLanguagelist.length > 0)
                values.push(newLanguagelist.pop());

            elements.unshift(`<ul class="list spCol2">`);
            elements.push(`</ul>`);
        }
        else {
            for (i = 0; i < initialLanguageNameList.length; i++) {
                elements.push(`<li><label><input id="${initialLanguageKeyList[i]}" name="${initialLanguageKeyList[i]}" type="checkbox" ><span></span><span>` + initialLanguageNameList[i].toUpperCase() + ` </span></label></li>`);
            }
            aggregate.buckets.forEach(entry => {
                let key = entry.key;
                //let docCount = entry.docCount;
                if (entry.fetchedKey && entry.fetchedKey.properties) {
                    let label = entry.fetchedKey.properties.label;
                    //let count = entry.docCount;

                    if (isALLSelected.length > 0)
                        values.push(key);
                    let checked = values.indexOf(key) >= 0 ? "checked" : "";
                    if ((initialLanguageNameList.indexOf(label) >= 0) && (values.indexOf(key) >= 0)) {
                        var labelUpper = label.toUpperCase();
                        elements.splice(initialLanguageNameList.indexOf(label), 1, `<li> <label> <input type="checkbox" id="${key}" name="${key}" ${checked}><span></span><span>${labelUpper}</span></label></li>`);
                    }
                }
            });
            elements.unshift(`<ul class="list spCol2">`);
            elements.push(`</ul>`);
            isALLSelected.pop();
        }
    }
    if (selector == "#res_productlist") {
        var categoryNameArray = [];
        var categoryCountArray = [];
        var typeNameArray = [];
        var typeCountArray = [];

        var first_type_in_new_category = false;

        for (var k = 0; k < documents.length; k++) {
            var productCategory = documents[k].properties['terumo_ifu:productCategory'];
            //category/type
            var productType = documents[k].properties['terumo_ifu:productCategory'] + "/" + documents[k].properties['terumo:producttype'];
            //let checked = values.indexOf(productCategory) >= 0 ? "checked" : "";

            //new category
            if (categoryNameArray.indexOf(productCategory) < 0) {
                categoryFilters.push(productCategory);
                categoryNameArray.push(productCategory);
                categoryCountArray.push(0);
                first_type_in_new_category = true;
            }
            //new type
            if ((first_type_in_new_category) || (typeNameArray[typeNameArray.length - 1] != productType)) {
                typeNameArray.push(productType);
                values.push(productType);
                typeCountArray.push(1);
                //for every new type, category count + 1
                //categoryCountArray[categoryNameArray.indexOf(productCategory)] += 1;
                categoryCountArray[categoryCountArray.length - 1] += 1;
                if (first_type_in_new_category)
                    first_type_in_new_category = false;
            }
            else {
                typeCountArray[typeNameArray.length - 1] += 1;
            }

        }
        //build original type list
        if (initialTypeList.length == 0) {
            initialTypeList = typeNameArray.slice();
        }
        if (initialCategoryNameArray.length == 0) {
            initialCategoryNameArray = categoryNameArray.slice();
            initialCategoryCountArray = categoryCountArray.slice();
            initialTypeNameArray = typeNameArray.slice();
            initialTypeCountArray = typeCountArray.slice();
        }

        // var index = 0;
        // for (k = 0 ; k < categoryNameArray.length; k++){
        //     elements.push(` <div class="titS">${categoryNameArray[k]}</div>`)
        //     for (var j = 0 ; j < categoryCountArray[k]; j++){
        //         elements.push(`<ul style= "margin-left: 1em" class="list"><li><label><input id="${typeNameArray[index]}" name="${typeNameArray[index]}" type="checkbox" checked><span></span><span>${typeNameArray[index]}(${typeCountArray[index]})</span></label></li></ul>`);

        //         index += 1 ;
        //     }
        // }

        category_type = [];
        var index = 0;
        var index_t = 0;
        for (k = 0; k < initialCategoryNameArray.length; k++) {
            if (categoryFilters.indexOf(initialCategoryNameArray[k]) >= 0)
                elements.push(`<ul class="list"><li><label><input id="category_${initialCategoryNameArray[k]}" name="${initialCategoryNameArray[k]}" type="checkbox" checked><span></span><span>${initialCategoryNameArray[k]}</span></label></li></ul>`);
            else
                elements.push(`<ul class="list"><li><label><input id="category_${initialCategoryNameArray[k]}" name="${initialCategoryNameArray[k]}" type="checkbox"><span></span><span>${initialCategoryNameArray[k]}</span></label></li></ul>`);
            let category_id = `category_${initialCategoryNameArray[k]}`;
            let type_id_list = [];
            //<div class="titS">${initialCategoryNameArray[k]}</div>
            for (j = 0; j < initialCategoryCountArray[k]; j++) {
                var temp = initialTypeNameArray[index];
                var type_value = temp.split("/")[1];
                if (typeNameArray.indexOf(temp) >= 0) {
                    elements.push(`<ul style= "margin-left: 1em" class="list"><li><label><input id="${temp}" name="${temp}" type="checkbox" checked><span></span><span>${type_value}(${typeCountArray[index_t]})</span></label></li></ul>`);
                    //elements.push(`<ul style= "margin-left: 1em" class="list"><li><label><input id="${temp}" name="${temp}" type="checkbox" checked><span></span><span>${temp}(${typeCountArray[index_t]})</span></label></li></ul>`);
                    index_t += 1;
                }
                else {
                    //elements.push(`<ul style= "margin-left: 1em" class="list"><li><label><input id="${temp}" name="${temp}" type="checkbox" ><span></span><span>${temp}</span></label></li></ul>`);
                    //elements.push(`<ul style= "margin-left: 1em"  class="list"><li><label><input id="${temp}" name="${temp}" type="checkbox" ><span></span><span>${temp}</span></label></li></ul>`);    
                    elements.push(`<ul style= "margin-left: 1em"class="list"><li><label><input id="${temp}" name="${temp}" type="checkbox" ><span></span><span>${type_value}(${initialTypeCountArray[index]})</span></label></li></ul>`);
                }

                type_id_list.push(temp);
                index += 1;
            }
            category_type[category_id] = type_id_list;
        }

    }
    resultPageList.html(elements.join("\n"));

    // Add listeners
    $(selector + " input").click(function (e) {
        if (selector != "#res_productlist") {
            //isResultCategoryFreezed = false;
            // typeFilters = Array.from(initialTypeList);
            typeFilters = initialTypeList.slice();
        }

        isClear = true;
        if (e.target.checked) {
            if (!e.target.id.startsWith('category_'))
                values.push(e.target.id);
            if (selector == "#res_productlist") {

                //call api for all new languages
                let param_new = {};
                var type_newClick = [];
                // if click category
                if (e.target.id.startsWith('category_')) {
                    //category_ has 9 digits
                    categoryFilters.push(e.target.id.slice(9));
                    for (let ids of category_type[e.target.id]) {
                        type_newClick.push(ids);
                        typeFilters.push(ids);
                    }

                } else {
                    type_newClick.push(e.target.id);
                }

                param_new.terumo_ifu_languages_agg = JSON.stringify(initialLanguageKeyList);
                param_new.es_productCategoryAndtype_agg = JSON.stringify(type_newClick);

                firstStepGetNewLanguage(param_new);
            }
            else {
                let queryParams = {};
                fetchResultPageDocuments(queryParams);
            }
        } else {
            if (e.target.id.startsWith('category_')) {
                if (categoryFilters.indexOf(e.target.id.slice(9)) >= 0) {
                    categoryFilters.splice(categoryFilters.indexOf(e.target.id.slice(9)), 1);
                }
                for (let ids of category_type[e.target.id]) {
                    if (values.indexOf(ids) >= 0) {
                        values.splice(values.indexOf(ids), 1);
                    }
                }

            } else {
                if (values.indexOf(e.target.id) >= 0) {
                    values.splice(values.indexOf(e.target.id), 1);
                }
            }

            let queryParams = {};
            fetchResultPageDocuments(queryParams);
        }



        //fetchNXQLDocuments(queryParams);
    });
}
function firstStepGetNewLanguage(param_new) {
    currentLanguageKeyList = [];
    fetchNewLanguage(param_new);
}

function secondStepGetNewLanguage() {
    console.log("return length = " + currentLanguageKeyList.length);
    currentLanguageKeyList.forEach(function (item) {
        if (languageFilters.indexOf(item) < 0)
            languageFilters.push(item);
    })
    let queryParams = {};
    fetchResultPageDocuments(queryParams);

}

function fetchNewLanguage(param) {
    // request API with parameter productCategory != "Australia" 
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                //    return;
            }
            getNewLanguage(data.aggregations.terumo_ifu_languages_agg);
            secondStepGetNewLanguage();
        })
        .catch(error => {
            console.log(error);
            return;
        });
}

function getNewLanguage(aggregate) {
    aggregate.buckets.forEach(entry => {
        let key = entry.key;
        if (entry.fetchedKey && entry.fetchedKey.properties) {
            let label = entry.fetchedKey.properties.label;
            if (initialLanguageNameList.indexOf(label) >= 0) {
                currentLanguageKeyList.push(key);
            }
        }
    });
}



function updateDocumentList(documents) {
    const productListEl = $("#list");

    if (documents.length === 0) {
        productListEl.html("No Results");
        return;
    }

    let elements = [];
    documents.forEach(entry => {
        var filePath = "";
        if (isEmpty(entry.properties['file:content'])) {
            // empty
        } else {
            filePath = entry.properties['file:content'].data;
        }
        elements.push(`<a class="document" href="${filePath}" >${entry.title}</a>`);
        //elements.push(`<a href="javascript:void(0);" onclick="openRequestedPopup(${filePath},${entry.title});"  >${entry.title}</a>`);

    });
    productListEl.html(elements.join("<br>"));
}


export function fetchQueryAZDocuments(param) {

    if (languageFilters.length > 0) {
        param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
    }
    if (isClear) {
        if (languageFilters.length == 0) {
            languageFilters.push("error");
            param.terumo_ifu_languages_agg = JSON.stringify(languageFilters);
            languageFilters.pop();
        }
    }
    if (queryFilters.length > 0) {
        param.terumo_ifu_brandName = "[" + queryFilters[0] + "].*";
    }

    param.pageSize = JSON.stringify(pageSizeLimite);
    param.sortBy = "terumo_ifu:brandName,terumo_wf:releaseDate";
    param.sortOrder = "ASC,DESC";
    // request API with parameter productCategory != "Australia" 
    param.terumo_ifu_productCategory_1 = "Australia";
    nuxeoClient.request('search/pp/website-search/execute', {
        schemas: ['dublincore', 'terumo', 'file', 'terumo_ifu', 'terumo_wf'],
        headers: {
            'fetch-aggregate': 'key',
            'fetch-document': 'terumo_ifu:factories'
        },
        queryParams: param
    })
        .get()
        .then(data => {
            if (data.entries.length === 0) {
                console.log("No Results");
                // return;
            }
            resultPageDocumentList(data.entries);
            updateQuerypageZFilters(data.aggregations, "queryAZ");
            updateDocumentList(data.entries);
            updateAtoZButtons();
        })
        .catch(error => {
            console.log(error);
        });
}

function updateQuerypageZFilters(aggregates, sign) {
    if (!isLanShouldBeFreezed) {
        updateQueryFilter("#res_languagelist", languageFilters, aggregates.terumo_ifu_languages_agg.buckets, sign);
    }
}

function updateQueryFilter(selector, values, buckets, sign) {
    const resultPageList = $(selector);
    const elements = [];

    if (initialQueryLanList.length == 0) {
        buckets.forEach(entry => {
            let key = entry.key;
            initialQueryLanList.push(key);
        })
    }

    if (selector == "#res_languagelist") {
        if (values.length > 0) {
            var sortLanKeyList = [];
            var sortLanNameList = [];

            buckets.forEach(entry => {
                let key = entry.key;
                if (entry.fetchedKey && entry.fetchedKey.properties) {
                    let label = entry.fetchedKey.properties.label;

                    if ((languageAllLists.indexOf(label) >= 0) && (values.indexOf(key) >= 0)) {
                        var labelUpper = label.toUpperCase();
                        sortLanKeyList.push(key);
                        sortLanNameList.push(labelUpper);
                        //elements.push(`<li><label><input type="checkbox" id="${key}" name="${key}" checked="checked"><span></span><span>${labelUpper}</span></label></li>`);
                    }
                }
            });
            sortLanNameList, sortLanKeyList = keyNameSort(sortLanNameList, sortLanKeyList);
            for (var i = 0; i < sortLanNameList.length; i++) {
                elements.push(`<li><label><input type="checkbox" id="${sortLanKeyList[i]}" name="${sortLanKeyList[i]}" checked="checked"><span></span><span>${sortLanNameList[i]}</span></label></li>`);
            }
            elements.unshift(`<ul class="list spCol2">`);
            elements.push(`</ul>`);
        }
        else {
            sortLanKeyList = [];
            sortLanNameList = [];
            buckets.forEach(entry => {
                let key = entry.key;

                if (entry.fetchedKey && entry.fetchedKey.properties) {
                    let label = entry.fetchedKey.properties.label;

                    values.push(key);
                    // let checked = values.indexOf(key) >= 0 ? "checked" : "";
                    if (languageAllLists.indexOf(label) >= 0) {
                        var labelUpper = label.toUpperCase();
                        sortLanKeyList.push(key);
                        sortLanNameList.push(labelUpper);
                        // elements.push(`<li><label><input type="checkbox" id="${key}" name="${key}" checked}><span></span><span>${labelUpper}</span></label></li>`);
                    }
                }
            });
            sortLanNameList, sortLanKeyList = keyNameSort(sortLanNameList, sortLanKeyList);
            for (i = 0; i < sortLanNameList.length; i++) {
                elements.push(`<li><label><input type="checkbox" id="${sortLanKeyList[i]}" name="${sortLanKeyList[i]}" checked="checked"><span></span><span>${sortLanNameList[i]}</span></label></li>`);
            }
            elements.unshift(`<ul class="list spCol2">`);
            elements.push(`</ul>`);
        }
    }

    resultPageList.html(elements.join("\n"));

    // Add listeners
    $(selector + " input").click(function (e) {
        isClear = true;
        if (e.target.checked) {
            values.push(e.target.id);
        } else {
            if (values.indexOf(e.target.id) >= 0) {
                values.splice(values.indexOf(e.target.id), 1);
            }
        }
        if (selector == "#res_languagelist") {

            let queryParams = {};
            isLanShouldBeFreezed = true;
            if (sign == "queryAZ") {
                fetchQueryAZDocuments(queryParams);
                return;
            }

            if (sign == "brand&code") {
                fetchDocuments(queryParams);
                return;
            }
        }
    });
}

function keyNameSort(list1, list2) {
    for (var i = 0; i < list1.length - 1; i++) {
        for (var j = i + 1; j < list1.length; j++) {
            if (list1[i] > list1[j]) {
                var tmp = list1[j];
                list1[j] = list1[i];
                list1[i] = tmp;
                tmp = list2[j];
                list2[j] = list2[i];
                list2[i] = tmp;
            }
        }
    }
    return list1, list2;
}
function updateAtoZButtons(/*values*/) {
    const queryListEl = $("#query_atoz");
    const elements = [];

    elements.push(`<div class="sel"> <ul class="tile">`);
    for (var i = 0; i < 26; i++) {
        elements.push(`<li><label><input type="radio" id=` + queryAllLists[i] + ` name="al"><span>` + String(queryAllLists[i]).slice(0, 1) + `</span></label></li>`);
    }
    elements.push(`</ul><ul class="tile">`);
    for (var j = 26; j < 36; j++) {
        elements.push(`<li><label><input type="radio" id=` + queryAllLists[j] + ` name="al"><span>` + String(queryAllLists[j]).slice(0, 1) + `</span></label></li>`);
    }
    elements.push(`</ul></div>`);

    if (queryFilters.length > 0) {
        var change_index = queryAllLists.indexOf(queryFilters[0]);
        if (change_index < 26)
            change_index += 1;
        else
            if (change_index < 36)
                change_index += 2;

        elements.splice(change_index, 1, `<li><label><input type="radio" id=` + queryFilters[0] + ` name="al" checked><span><b>` + String(queryFilters[0]).slice(0, 1) + `</b></span></label></li>`);
    }


    queryListEl.html(elements.join("\n"));

    //button click listener
    $("#query_atoz input").click(function (e) {
        if (queryFilters.indexOf(e.target.id) >= 0)
            queryFilters.pop();
        else {
            if (queryFilters.length > 0)
                queryFilters.pop();
            queryFilters.push(e.target.id);
        }
        for (var j = 0; j < initialQueryLanList.length; j++)
            if (languageFilters.indexOf(initialQueryLanList[j]) < 0)
                languageFilters.push(initialQueryLanList[j]);
        isLanShouldBeFreezed = false;
        let queryParams = {};
        fetchQueryAZDocuments(queryParams);
    });
}

function isEmpty(str) {
    if (typeof str == "undefined" || str == null || str == "")
        return true;
    else
        return false;
}

function isEmptyReturnVelue(str) {
    if (typeof str == "undefined" || str == null || str == "")
        return "-";
    else
        return str;
}

export function ListEvent() {
    /////////////////
    $('.resultList .item').each(itemAct);

    function itemAct(i) {
        var $me = $(this);
        //if($me.closest('.oldVer')[0]) return false;


        if (!rowSet.has(i)) {
            var _display = $('header .headerInr .menu').css('display');
            if (_display === 'none') {
                $me.find('.itemHead th span').hide();
                $me.find('.itemHead th').hide();
            }
        }
        $me.find('button').on('click', function () {


            var _display = $('header .headerInr .menu').css('display');
            if ($(this).hasClass('minus')) {
                $(this).removeClass('minus');
                $me.removeClass('open');

                ///自分自身
                $me.find('.info').slideUp();
                if ($me.prev().hasClass('open')) {
                    //何もしない
                } else if (!rowSet.has(i)) {
                    if (_display === 'none') {
                        $me.find('.itemHead thead tr th span').slideUp('normal', function () {
                            $(this).parent().hide();
                        });
                    }
                }

                ///下の要素
                if ($('header .headerInr .menu').css('display') === 'none') {
                    if (_display === 'none') {
                        if ($me.next().hasClass('open')) {
                            //何もしない
                        } else {
                            $me.next().find('.itemHead thead tr th span').slideUp('normal', function () {
                                $(this).parent().hide();
                            });
                        }
                    }
                }
            } else {
                $(this).addClass('minus');

                ///自分自身
                $me.addClass('open');
                $me.find('.info').slideDown();

                if (_display === 'none') {
                    $me.find('.itemHead thead tr th').show();
                    $me.find('.itemHead thead tr th span').slideDown();
                }

                ///下の要素
                if (_display === 'none') {
                    $me.next().find('.itemHead thead tr th').show();
                    $me.next().find('.itemHead thead tr th span').slideDown();
                }
            }

            return false;
        });
    }

    if ($('.resultList .item .itemHead')[0]) {
        $(window).on('resize.result', onresultresize);
        onresultresize();
    }

}

function topListSet() {

    ////トップリサイズ
    var ontopresize = function () {
        var _display = $('header .headerInr .menu').css('display');
        if (_display === 'none') {
            //var len = $('ul.vertical.products li').length;
            //var col = Math.ceil(len/3);
            var ht = 0;
            var allHt = 0;
            $('ul.vertical.products li').each(function () {
                allHt = allHt + $(this).outerHeight();
                if (ht < $(this).outerHeight()) {
                    ht = $(this).outerHeight();
                }
            });
            allHt = Math.floor(allHt / 3);
            allHt = allHt + ht;
            $('ul.vertical.products').css({
                height: allHt
            });
        } else {
            $('ul.vertical.products').css({
                height: ''
            });
        }
    };
    if ($('ul.vertical.products')[0]) {
        $(window).on('resize.products', ontopresize);
        ontopresize();
    }
}

function afterTimer() {
    if (numTimer == 2) {
        if (window.location.hash === '#showTerm') {
            showTerm();
        }
        if (window.location.hash === '#showPolicy') {
            showPolicy();
        }
        if (window.location.hash === '#showPolicyPop') {
            showPolicy();
        }
    }
}

function showTerm() {
    $('html').addClass('showTerm');
    var $term = $('[data-role="term"]');
    var top = $term.offset().top;
    $('html,body').animate({
        scrollTop: top
    });
    $term.addClass('open');
    $term.find('.storage').slideDown();
}

function showPolicy() {
    $('html').addClass('showPolicy');
    var $policy = $('[data-role="policy"]');
    var top = $policy.offset().top;
    $('html,body').animate({
        scrollTop: top
    });

    $policy.addClass('open');
    $policy.find('.storage').slideDown();
}


function old_version_event() {
    $('.oldVer').each(oldVerAct);
    function oldVerAct() {
        var scrollTop = 0;
        var $me = $(this);
        $me.hide();

        var oldVerClose = function () {
            $me.fadeOut('normal', function () {
                $('body').css({
                    top: scrollTop,
                    position: 'static',
                    overflow: 'visible'
                });
                $(window).scrollTop(scrollTop);
            });
        };

        $me.next().on('click', function () {


            var $me_new = $me.prev('.item');
            var $button = $me_new.find('.btnCircle');
            var _display = $('header .headerInr .menu').css('display');
            if ($button.hasClass('minus')) {
                //command
            } else {
                $button.addClass('minus');

                ///自分自身
                $me_new.addClass('open');
                $me_new.find('.info').slideDown();

                if (_display === 'none') {
                    $me_new.find('.itemHead thead tr th').show();
                    $me_new.find('.itemHead thead tr th span').slideDown();
                }

                ///下の要素
                if (_display === 'none') {
                    $me_new.next().find('.itemHead thead tr th').show();
                    $me_new.next().find('.itemHead thead tr th span').slideDown();
                }
            }

            scrollTop = $(window).scrollTop();
            $('body').css({
                top: scrollTop * -1,
                left: 0,
                right: 0,
                position: 'fixed',
                overflow: 'hidden'
            });
            $me.fadeIn();
            onresultresize();
            return false;
        });
        $me.find('.btnClose').on('click', function () {
            oldVerClose();


            // //below is to slide_up the previous IFU 
            // var $me_new= $me.prev('.item');
            // var $button =  $me_new.find('.btnCircle');
            // var _display = $('header .headerInr .menu').css('display');
            // if ($button.hasClass('minus')) {
            //     $button.removeClass('minus');
            //     $me_new.removeClass('open');

            //     ///自分自身
            //     $me_new.find('.info').slideUp();
            //     if ($me_new.prev().hasClass('open')) {
            //         //何もしない
            //     } else if (!rowSet.has(i)) {
            //         if (_display === 'none') {
            //             $me_new.find('.itemHead thead tr th span').slideUp('normal', function () {
            //                 $button.parent().hide();
            //             });
            //         }
            //     }

            //     // ///下の要素
            //     // if ($('header .headerInr .menu').css('display') === 'none') {
            //     //     if (_display === 'none') {
            //     //         if ($me_new.next().hasClass('open')) {
            //     //             //何もしない
            //     //         } else {
            //     //             $me_new.next().find('.itemHead thead tr th span').slideUp('normal', function () {
            //     //                 $button.parent().hide();
            //     //             });
            //     //         }
            //     //     }
            //     // }
            // }



            return false;
        });
        $me.on('click', function (e) {
            if (e.target === e.currentTarget) {
                oldVerClose();
            }

            // return false;
        });
    }
}

//検索結果リサイズ
var onresultresize = function () {
    var _display = $('header .headerInr .menu').css('display');
    if (_display === 'none') {
        $('.resultList .item .itemHead').each(function () {
            var $itemHead = $(this);
            var ht = 0;
            $itemHead.find('td').each(function () {
                var oh = $(this).outerHeight();
                if (oh == 0) oh = 53;
                if (ht < oh) ht = oh;
            });

            $itemHead.find('td').css({
                height: ht
            });
        });
    }
};
